import { CANVAS } from "@/apollo/queries/canvas";
import MetaTags from "@/components/MetaTags/index";
import config from "@/lib/config";
import { CANVAS_PAGE_LIMIT, defaultMetatags } from "@/lib/constants";
import routes from "@/lib/routes";
import withMiddlewares from "@/middlewares/withMiddlewares";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { useMemo } from "react";
const Canvas = dynamic(() => import("@/components/Canvas"));

/**
 * getIdKey.
 *
 * @param {string} slug
 */
function getIdKey(slug) {
  return `canvas_${slug}`;
}

export default function CanvasPage({ title, metatags }) {
  const router = useRouter();

  const key = useMemo(() => {
    return getIdKey(router.query.slug);
  }, [router]);

  return (
    <>
      <MetaTags {...metatags} />
      <Canvas idKey={key} title={title} />
    </>
  );
}

export const getServerSideProps = withMiddlewares(
  async ({ req, query }, { serverProps, error, apolloClient }) => {
    const idKey = getIdKey(query.slug);

    if (!idKey) {
      return { notFound: true };
    }

    try {
      const { data } = await apolloClient.query({
        query: CANVAS,
        variables: {
          idKey: idKey.toString(),
          offset: 0,
          limit: CANVAS_PAGE_LIMIT,
          withMeta: true,
        },
      });

      if (data.canvas) {
        const { meta } = data.canvas;
        const title = meta?.title || defaultMetatags["vod"].title;
        const keywords = meta?.keywords || defaultMetatags["vod"].keywords;
        const description =
          meta?.description || defaultMetatags["vod"].description;
        const host = config.host.vod;
        const metatags = {
          title,
          keywords,
          description,
          og: {
            type: "article",
            title,
            description,
            url: `${host}${routes.canvas(query.slug)}`,
          },
          twitter: { title, description },
        };
        return {
          props: {
            ...serverProps,
            metatags,
            title: meta?.title,
            error,
            initialApolloState: apolloClient.cache.extract(),
          },
        };
      } else {
        return { notFound: true };
      }
    } catch (e) {
      const status = e?.graphQLErrors?.[0]?.extensions?.response?.status;
      if (status === 404) {
        return { notFound: true };
      } else {
        throw e;
      }
    }
  }
);
